export const formatNumber = (number: number): string =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(number)

export const formatPercent = (number: number): string =>
  `${Math.round(number * 100)}%`
